import Phaser from "phaser"
// @ts-ignore

export default class GameOverScene extends Phaser.Scene {

    constructor() {
        super('game-over-scene')
    }

    init(data){
        this.score = data.score
        this.replayButton = undefined
    }

    preload() {
        this.load.image('bg-gameover', 'images/bg_gameover.png')
        this.load.image('game-over-text', 'images/gameover.png')
        this.load.image('replaylose-button', 'images/replayLose.jpg')
    }

    create(){
        this.add.image(200, 320, 'bg-gameover').setScale(0.3)
        this.add.image(200, 120, 'game-over-text')

        this.add.text(120, 450, 'Score: ', {
			fontSize: '33px',
			color: '#FFFFFF',
		});
		this.add.text(250, 450, this.score, {
			fontSize: '33px',
			color: '#FFFFFF',
		});


        this.replayButton = this.add.image(200, 550, 'replaylose-button').setInteractive().setScale(0.2)

        // ketika di klik, scene akan berpindah ke CoronaBusterScene
        this.replayButton.once('pointerup', () => {
            this.scene.start('hunting-alien-io')
        }, this)


    }
}